<template>
	<div
		class="delivery-list"
	>
		<template v-if="$_deliverySelect_deliveryAvailable">
			<div class="week-days-list">
				<select class="form-control" @change="$_deliverySelect_selectDelivery($event.target.value)" :value="$_deliverySelect_selectedIndexDaySelect">
					<option :value="index" v-for="(option, index) in shipmentZonesStore.shipmentZones.available">{{ $_dates_readableDate(option.delivery_date_estimated) }}</option>
				</select>
			</div>

		</template>

		<template v-else>
			Caricamento...
		</template>
	</div>
</template>

<script>

import { deliverySelect } from '../../mixins/delivery'
import { dates } from '../../mixins/dates'

export default {
	data () {
		return {
			optionValue: null
		}
	},

	mixins: [
		dates,
		deliverySelect
	],
	
	mounted() {
		if (this.$_deliverySelect_selectedIndexDaySelect == null) {
			this.$_deliverySelect_selectDelivery(0)
		}
	}
}

</script>

<style scoped>

	.delivery-list {
		padding-top: 0px;
		max-width: 700px;
	}

	.estimated-date {
		padding-top: 20px;
	}

	.small-text {
		font-size: 11px;
	}

	.week-day {
		border: 1.5px solid #ededed;
		border-radius: 4px;
		line-height: 31px;
		text-align: center;
		cursor: pointer;
		margin: 10px 0;
		flex-grow: 1;
		padding: 0 5px;
		flex-wrap: wrap;
	}

	.week-day {
		margin-left: 5px;
		margin-right: 5px;
	}
	.week-day[data-unavailable] {
		background-color: #ededed;
		cursor: default;
	}

	[data-delivery-day="0"] {
		display: flex;
	}

	[data-unavailable] [data-delivery-day="0"] {
		display: flex;
	}


	.delivery {
		border-radius: 4px;
		border: 1.5px solid #ededed;
		margin: 10px 0;
		padding: 10px;
		cursor: pointer;
		display: flex;
	}

	.delivery.selected {
		border: 1.5px solid var(--quomi-primary);
	}

	.delivery-label {
		font-size: 15px;
	}

	.delivery-info .price {
		font-size: 15px;
		text-transform: uppercase;
		font-weight: bold;
	}

	.delivery-label {
		font-size: 15px;
	}

	.delivery-rightbox {
		margin: 0 0 0 auto;
	}

	.delivery-info {
		text-align: left;
	}

	.delivery-info .price {
		font-size: 15px;
		text-transform: uppercase;
		font-weight: bold;
	}

	.no-delivery {
		border-radius: 4px;
		border: 1.5px solid #ededed;
		padding: 10px;
		margin: 20px 0;
	}

	.week-days-list {
		padding-bottom: 20px;
		display: flex;
		flex-wrap: wrap;
		margin: 0 -5px;
	}
</style>
